import { lazy, Suspense, useState } from "react";
import { ArtShowcase } from "./components/ArtShowcase/ArtShowcase";
import { ChibiWalker } from "./components/ChibiWalker/ChibiWalker";
import { DormViewer } from "./components/DormViewer/DormViewer";
import { HistoryScroll } from "./components/HistoryScroll/HistoryScroll";
import { Infographic } from "./components/Infographic/Infographic";
import { ErrorBoundary } from "./components/layout/ErrorBoundary";
import { Footer } from "./components/layout/Footer";
import { Hero } from "./components/layout/Hero";
import { Nav } from "./components/layout/Nav";
import { Sounds } from "./components/Sounds/Sounds";

const RifleViewer = lazy(async () => {
  const mod = await import("./components/RifleViewer/RifleViewer");
  return { default: mod.RifleViewer };
});

export function App() {
  const [chibi, setChibi] = useState(true);

  return (
    <>
      <div className="grain" aria-hidden="true" />
      <Nav chibiEnabled={chibi} onToggleChibi={() => setChibi((v) => !v)} />
      <main>
        <Hero />
        <ErrorBoundary
          fallback={
            <section id="rifle" style={{ minHeight: 240, padding: "2rem 1.25rem" }}>
              <h2>Rifle viewer unavailable</h2>
            </section>
          }
        >
          <Suspense fallback={<section id="rifle" style={{ minHeight: 480 }} />}>
            <RifleViewer />
          </Suspense>
        </ErrorBoundary>
        <HistoryScroll />
        <ErrorBoundary
          fallback={
            <section id="dorm" style={{ minHeight: 240, padding: "2rem 1.25rem" }}>
              <h2>Dorm viewer unavailable</h2>
            </section>
          }
        >
          <DormViewer />
        </ErrorBoundary>
        <Infographic />
        <ArtShowcase />
        <Sounds />
      </main>
      <Footer />
      <ChibiWalker enabled={chibi} />
    </>
  );
}
